import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Ring.module.scss'

const propTypes = {
  animate: PropTypes.bool,
  color: PropTypes.oneOf(['white', 'blue'])
}

const defaultProps = {
  animate: true,
  color: 'blue'
}

const Ring = ({ className, animate, children, color, ...restProps }) => (
  <span
    className={classnames(
      className,
      styles.root,
      animate && styles.animate,
      styles[`color-${color}`]
    )}
  >
    {children}
  </span>
)

Ring.propTypes = propTypes
Ring.defaultProps = defaultProps

export default Ring
